import React, { useState } from "react";
import Button from "../common/Button.jsx";
import styled from "styled-components";
import useMediaQuery from "@mui/material/useMediaQuery";
import { printTickets } from "../../utils/PrintUtils.js";

const Container = styled("div")(({ isInDrawer }) => ({
  padding: "0 0 16px 0",
  maxWidth: isInDrawer ? "auto" : "500px",
  margin: "0 auto",
  "> * ": {
    fontFamily: "pf_highway_sans_pro_lightRg",
  },
}));

const SelectAllButton = styled("button")({
  color: "#703EFF",
  fontWeight: 600,
  fontSize: 14,
  background: "none",
  border: "none",
  cursor: "pointer",
  paddingLeft: 0,
  "&:hover": {
    color: "#502CB5",
    textDecoration: "none"
  }
});

const TicketList = styled("div")(({ isInDrawer }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  maxHeight: isInDrawer ? "calc(100vh - 303px)" : "calc(100vh - 305px)",
  minHeight: isInDrawer ? "auto" : "calc(100vh - 560px)",
  overflowY: "auto",
  scrollbarWidth: "thin",
  scrollbarColor: "darkgray #CFD1D1"
}));

const TicketCard = styled("div")({
  display: "flex",
  alignItems: "start",
  gap: "8px",
  paddingBottom: "16px",
  borderBottom: "1px solid #EDF1F6",
  background: "#FFFFFF",
});

const CheckboxContainer = styled("div")({});

const CustomCheckbox = styled("input")({
  width: "24px",
  height: "24px",
  cursor: "pointer",
  appearance: "none",
  borderRadius: "4px",
  marginLeft: 0,
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  "&:checked": {
    backgroundImage: "url('/Site/images/icons/order-details/checked.svg')",
  },
  "&:not(:checked)": {
    backgroundImage: "url('/Site/images/icons/order-details/unchecked.svg')",
  },
});

const ImageContainer = styled("div")({
  width: "64px",
  height: "64px",
  background: "#f3f4f6",
  borderRadius: "8px",
  overflow: "hidden",

  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
});

const TicketDetails = styled("div")({
  flex: 1,
  display: "grid",
  gap: "2px 6px",
  marginLeft: 8,
});

const Label = styled("div")({
  color: "#a8abaf",
  fontSize: "14px",
  fontWeight: 400,
  "> span:last-of-type": {
    color: "#0D0C1C",
  },
  "> span:first-of-type": {
    marginRight: 6,
  },
});

const ButtonContainer = styled("div")(({isInDrawer}) => ({
  position: isInDrawer ? "absolute" : "sticky",
  bottom: 0,
  left: 0,
  width: "100%",
  backgroundColor: "white",
  boxShadow: isInDrawer ? "0 10px 10px rgba(0,0,0,0.05)" : "0 0 10px rgba(0,0,0,0)",
  padding: isInDrawer ? "16px" : "8px 0",
  zIndex: 10,
}))

const PrintTicketsModal = ({ tickets, travelBaseUrl}) => {
  const [selectedTickets, setSelectedTickets] = useState([]);
  const isInDrawer = useMediaQuery("(max-width:899px)");
  const contentId = document.getElementById('OrderContentId').value;
  const handlePrint = async () => {
    const ticketsToPrint = tickets.filter((ticket) =>
      selectedTickets.includes(ticket.id)
    );
      printTickets(ticketsToPrint, travelBaseUrl, contentId);
  };

  const toggleTicketSelection = (ticketId) => {
    if (selectedTickets.includes(ticketId)) {
      setSelectedTickets(selectedTickets.filter((id) => id !== ticketId));
    } else {
      setSelectedTickets([...selectedTickets, ticketId]);
    }
  };

  const handleSelectAll = () => {
    if (selectedTickets.length === tickets.length) {
      setSelectedTickets([]);
    } else {
      setSelectedTickets(tickets.map((t) => t.id));
    }
  };
  return (
    <>
      <div>
        <Container isInDrawer={isInDrawer}>
          {tickets.length > 1 && <SelectAllButton id="selectAllTickets" onClick={handleSelectAll}>
            {selectedTickets.length === tickets.length
              ? orderdetails_resources.DeselectAll
              : orderdetails_resources.SelectAll}
          </SelectAllButton>}

          <TicketList isInDrawer={isInDrawer} style={{ paddingBottom: isInDrawer ? 96 : 0, marginTop: 16 }}>
            {tickets.map((ticket) => (
              <TicketCard key={ticket.id}>
                <CheckboxContainer>
                  <CustomCheckbox
                    type="checkbox"
                    checked={selectedTickets.includes(ticket.id)}
                    onChange={() => toggleTicketSelection(ticket.id)}
                  />
                </CheckboxContainer>

                    <ImageContainer id="ticketImage">
                        <img src={ticket.imageUrl ? ticket.imageUrl : '/Site/images/icons/order-details/noImage.svg'} alt={ticket.title} />
                </ImageContainer>

                <TicketDetails id="ticketDetails">
                  <Label>
                    <span>{orderdetails_resources.NameSurname}</span>
                    <span id="name">{ticket.nameSurname}</span>
                  </Label>

                  <Label>
                    <span>{orderdetails_resources.ZoneDiscount}</span>
                    <span id="zone">{ticket.zone}</span>
                  </Label>

                  <Label>
                    <span>{orderdetails_resources.Section}</span>
                    <span id="section">{ticket.section}</span>
                  </Label>

                  <Label>
                    <span>{orderdetails_resources.RowSeat}</span>
                    <span id="roeSeat">
                      {ticket.rowSeat === "Unnumbered"
                        ? orderdetails_resources.Unnumbered
                        : ticket.rowSeat}
                    </span>
                  </Label>
                   <Label>
                     <span>{orderdetails_resources.Price}</span>
                     <span id="price">{ticket.price}</span>
                   </Label>
              </TicketDetails>
            </TicketCard>
          ))}
        </TicketList>
      </Container>
     </div>
      <ButtonContainer isInDrawer={isInDrawer}>
        <Button
          type="primary"
          fullWidth
          height={"48px"}
          text={isInDrawer ? orderdetails_resources.DownloadTickets  : orderdetails_resources.PrintTickets}
          onClick={handlePrint}
          disabled={selectedTickets.length === 0}
        />
      </ButtonContainer>
    </>
  );
};
export default PrintTicketsModal;
